module.exports = __webpack_public_path__ + "img/Z60_08.a9670651.jpg";